export default __webpack_public_path__ + "static/media/slide6.f2193d65.jpg";